<template>
  <div class="content noHeader">
    <div @click="changePerson" v-if="$storage.get('patient')">
      <el-row style="height: 1rem;background-color: #fff;margin-bottom: .1rem;color: #666666;">
        <el-col :span="5">
          <div style="height: 1rem;line-height: 1rem;margin-left: .3rem">{{$storage.get('patient').clinic_patient_name}}</div>
        </el-col>
        <el-col :span="16">
          <div style="height: 1rem;line-height: 1rem;">
            <span>{{$storage.get('patient').clinic_num?$storage.get('patient').clinic_num:'000000'}}</span>
            <span style="float: right;color:#e02c06;font-weight: 700;font-size: .32rem">换人</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="height: 1rem;line-height: 1.3rem;padding-left: .1rem;">
            <img src="static/img/huanren.png" style="width: .5rem;height: .5rem"/>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="$storage.get('patient')">
      <el-row style="height: 1rem;background-color: #fff;margin-bottom: .1rem;color: #666666;">
        <el-col :span="17">
          <div style="height: 1rem;line-height: 1rem;margin-left: .3rem;">缴费总金额</div>
        </el-col>
        <el-col :span="6">
          <div style="height: 1rem;line-height: 1rem;margin-right:.1rem;text-align: right;color: red">￥{{amount}}</div>
        </el-col>
      </el-row>
    </div>
    <div v-if="payList.length>0" style="margin-bottom: 1.5rem;">
      <el-table :data="payList" style="width: 100%" border :header-cell-style="{background:'#87CEFA',color:'#fff'}">
        <el-table-column prop="项目名称" label="项目名称" width="140" align="center"></el-table-column>
        <el-table-column prop="单位" label="单位" min-width="20" align="center"></el-table-column>
        <el-table-column prop="数量" label="数量" min-width="20" align="center"></el-table-column>
        <el-table-column prop="单价" label="单价" min-width="20" align="center"></el-table-column>
      </el-table>
      <div style="margin-left: .3rem">仅适用于自费缴费，医保报销请到窗口办理，谢谢。</div>
    </div>
    <div class="noCard" v-if="!payList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无缴费内容</div>
    </div>
    <div class="pay-btm" v-if="payList.length>0">
      <div style="line-height: 1rem;margin-right: .3rem;text-align: right">
        <span style="float: left;margin-left: .5rem;">合计：<span style="color: red">{{amount}}</span></span>
        <el-button style="color: #fff;background-color: red" size="mini" @click="pay">支&nbsp&nbsp付</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {getmzfeelist,paymzfeelist,paymzfeelist_bypay_after} from '../../api/index'
  export default {
    data(){
      return{
        payList:[],
        amount:0,
        nos:''
      }
    },
    created() {
      //修改标题
      document.title = '门诊缴费'
      if(this.$storage.get('patient')){
        this.getList()
      }
    },
    methods:{
      //获取缴费列表
      getList(){
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        getmzfeelist({
          name:this.$storage.get('patient').clinic_patient_name,
          cardnum:this.$storage.get('patient').clinic_num,
          healthcardno:this.$storage.get('patient').healthCardId,
          patientid:this.$storage.get('patient').patient_id,
        }).then(res=>{
          loading.close();
          this.amount = res.Data.length>0?res.Data[0].总金额:0
          this.payList = res.Data
          res.Data.forEach(e=>{
            this.nos += e.NO+','
          })
        })
      },
      //换人
      changePerson(){
        this.$router.push({path:'/selectPerson'})
      },
      //支付
      pay(){
        const self = this
        paymzfeelist({
          // order_id: "string",
          amount: this.amount,
          clinic_card_num: this.$storage.get('patient').clinic_num,
          clinic_patient_name: this.$storage.get('patient').clinic_patient_name,
          nos: this.nos.substring(0,this.nos.length-1),
          // pay_status: 0,
          // pay_time: "2020-07-07T03:03:46.603Z",
          user_open_id: this.$storage.get('openid'),
          // out_trade_no: "string",
          HealthCardId: this.$storage.get('patient').healthCardId,
          PatientId: this.$storage.get('patient').patient_id,
          // his_returncode: "string",
          // his_returnmsg: "string"
        }).then(res=>{
          if(!res.IsSuccess){
            this.$message({
              message: res.Msg,
              type: 'error',
              duration:3000,
              center:true,
              offset:200
            });
          }else {
            //支付
            let wxJsonApiParam =  JSON.parse(res.Data.WxJsonData.wxJsonApiParam)
            let order_id = res.Data.RecoredID
            function onBridgeReady() {
              WeixinJSBridge.invoke(
                'getBrandWCPayRequest', wxJsonApiParam,
                function(res) {
                  if(res.err_msg == "get_brand_wcpay_request:ok") {
                    self.$message({
                      message: '支付成功！',
                      type: 'success',
                      duration:3000,
                      center:true,
                      offset:200
                    });
                    // paymzfeelist_bypay_after({
                    //   order_id:order_id,
                    //   paystatus:1,
                    //   openid:self.$storage.get('openid')
                    // }).then(res=>{
                    //
                    // })
                    self.getList()
                  }else {
                    self.$message({
                      message: '支付失败！',
                      type: 'error',
                      duration:3000,
                      center:true,
                      offset:200
                    });
                    // paymzfeelist_bypay_after({
                    //   order_id:order_id,
                    //   paystatus:2,
                    //   openid:self.$storage.get('openid')
                    // }).then(res=>{
                    //
                    // })
                    self.getList()
                  }
                }
              );
            }
            if(typeof WeixinJSBridge == "undefined") {
              if(document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
              } else if(document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
              }
            } else {
              onBridgeReady();
            }
          }
        })
      },
    }
  }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .3rem;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
  .pay-btm{
    width: 100%;
    height: 1rem;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/pay.vue